const module = {
  firestorePath: 'users',
  firestoreRefType: 'collection', // or 'doc'
  moduleName: 'user',
  statePropName: 'data',
  namespaced: true, // automatically added

  sync: {
    defaultValues: {
      id: '',
      displayName: '',
      email: '',
      emailVerified: '',
      phoneNumber: '',
      photoURL: '',
      note: '',
      roles: {},
      isDeleted: false
    }
  },

  // this object is your store module (will be added as '/myModule')
  // you can also add state/getters/mutations/actions
  state: {},
  getters: {
    arrayData: state => {
      let data = []

      for (const key in state.data) {
        if (state.data.hasOwnProperty(key)) {
          data.push(state.data[key]);
        }
      }

      return data
    },
    member: (state, getters) => {
      return getters.arrayData.filter(i => { return (i.roles.member === true)})
    },
    marketing: (state, getters) => {
      return getters.arrayData.filter(i => { return (i.roles.marketing === true)})
    },
    staff: (state, getters) => {
      return getters.arrayData.filter(i => { return (i.roles.staff === true)})
    }
  },
  mutations: {},
  actions: {},
}

export default module
